var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{class:[
    `cv-form-group ${_vm.carbonPrefix}--fieldset`,
    {
      [`${_vm.carbonPrefix}--fieldset--no-margin`]: _vm.noMargin,
    },
  ],attrs:{"data-invalid":_vm.invalid}},[_c('legend',{class:`${_vm.carbonPrefix}--label`},[_vm._t("label")],2),_vm._t("content"),(_vm.message)?_c('div',{class:`${_vm.carbonPrefix}--form__requirements`},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }